import { ReportEntity, WorkDayUserEntity } from '@data/utils/types';

/** Products the edit dialog leaves out: those holding another entry that day, never the entry's own, which may hold several. */
export const productsTakenOnDay = (workDays: WorkDayUserEntity[], day: string, entry: ReportEntity): string[] => {
  const ownProductId = entry.involvement.product.id;
  const taken = (workDays.find(workDay => workDay.date === day)?.reports ?? [])
    .filter(report => !report.incidentId)
    .map(report => report.involvement.product.id)
    .filter(productId => productId !== ownProductId);

  return [...new Set(taken)];
};
